<template>
  <div class="app-main-content">
    <h1>Registration fee estimate</h1>
    <p>
      Listed below is an estimated fee of the Registration cost that will be incurred to register the vehicle with the
      plate type you listed on the previous page as of <span>{{ today }}</span>. Please read the disclaimer below for additional
      information on this quote.
    </p>

    <EstimateFee />

    <EstimateDisclaimer />

    <BaseButtonGroup>
      <template #default>
        <button @click="onBack">
          Back
        </button>
        <button class="app-btn-primary" @click="onPrint">
          Print
        </button>
      </template>
    </BaseButtonGroup>
  </div>
</template>


<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'
import appConfig from '@/app.config'
import EstimateFee from "../../components/modules/quote/EstimateFee"
import EstimateDisclaimer from "../../components/modules/quote/EstimateDisclaimer"
import BaseButtonGroup from "../../components/ui/BaseButtonGroup"
import { toDay } from "../../utils/helpers"

defineOptions({
  name: 'QuoteEstimate',
})

// Manage page metadata with `useHead`
useHead({
  title: `Registration Fee Estimate | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'Get an estimated fee of the Registration cost that will be incurred to register the vehicle ' +
        'with a selected plate type on a given date.'
    }
  ]
})

// Vuex router 
const router = useRouter();

// computed property 
const today = computed(() => {
  return toDay()
})

// Methods
const onBack = () => {
  router.push({ name: 'QuoteLookup' })
}

const onPrint = () => {
  window.print()
}
</script>


<style lang="scss" scoped>
span {
  @extend %font-sans-bold;
}
</style>
